import { useTranslation } from 'react-i18next'
import { Link, useNavigate } from 'react-router-dom'
import { LogOut, XamaAiBadge } from '../../assets/svgs/icons'
import upgrade from '../../assets/logos/upgrade.svg'
import ArtLimitProgress from '../ArtLimitProgress'
import SidebarNavigation from './SidebarNavigation'
import SidebarUtilityActions from './SidebarUtilityActions'
import { MIN_ARTS_TO_CREATE_CAMPAIGN } from '../../constants/campaignCreation'

const SidebarCollapsedRail = ({
  onToggleExpanded,
  onCreate,
  isCampaignCreationBlocked,
  artesCriadas,
  limiteArtes,
  userInitial,
  onLogout,
}) => {
  const { t } = useTranslation()
  const navigate = useNavigate()

  return (
    <div className="sidebar-collapsed-rail">
      <div className="sidebar-collapsed-top">
        <div className="sidebar-collapsed-logo-wrap">
          <Link to="/ChatSocket" className="sidebar-collapsed-logo" aria-label="Xamã">
            <XamaAiBadge width={38} height={28} />
          </Link>

          <button
            type="button"
            className="sidebar-collapsed-icon-btn sidebar-collapsed-expand-btn"
            onClick={onToggleExpanded}
            aria-label={t('campaign_history_sidebar.expand_menu')}
            title={t('campaign_history_sidebar.expand_menu')}
          >
            <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
              <rect x="1.5" y="2.5" width="15" height="13" rx="2" stroke="#414141" strokeWidth="1.2" />
              <path d="M6.5 2.5V15.5" stroke="#414141" strokeWidth="1.2" />
            </svg>
          </button>
        </div>

        <button
          type="button"
          className={`sidebar-collapsed-create-btn${isCampaignCreationBlocked ? ' disabled' : ''}`}
          onClick={onCreate}
          disabled={isCampaignCreationBlocked}
          aria-label={t('campaign_history_sidebar.new_conversation')}
          title={
            isCampaignCreationBlocked
              ? t('campaign_history_sidebar.insufficient_arts_tooltip', { min: MIN_ARTS_TO_CREATE_CAMPAIGN })
              : t('campaign_history_sidebar.new_conversation')
          }
        >
          <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M7 1V13M1 7H13" stroke="white" strokeWidth="2" strokeLinecap="round" />
          </svg>
        </button>

        <ArtLimitProgress
          artesCriadas={artesCriadas}
          limiteArtes={limiteArtes}
          layout="collapsed"
        />
      </div>

      <div className="sidebar-collapsed-nav">
        <SidebarNavigation variant="collapsed" />
      </div>

      <div className="sidebar-collapsed-bottom">
        <div className="sidebar-collapsed-user-actions">
          <SidebarUtilityActions variant="collapsed" menuPlacement="top" />

          <button
            type="button"
            className="sidebar-collapsed-logout-btn"
            onClick={onLogout}
            aria-label={t('log_out.button_log_out')}
          >
            <LogOut width={20} height={20} color="rgba(65, 65, 65, 0.73)" />
          </button>
        </div>
        <button
          type="button"
          className="sidebar-collapsed-upgrade-btn"
          onClick={() => navigate('/PlanCheckoutUser')}
          aria-label={t('campaign_history_sidebar.upgrade_plan')}
        >
          <img src={upgrade} alt="" className="sidebar-collapsed-upgrade-icon" />
        </button>

        <div className="sidebar-collapsed-avatar" aria-hidden="true">
          {userInitial}
        </div>
      </div>
    </div>
  )
}

export default SidebarCollapsedRail
